import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

function Home() {
  const { user } = useContext(AuthContext);

  return (
    <div className="max-w-6xl mx-auto">
      {/* Hero Section */}
      <div className="text-center py-12">
        <h1 className="text-5xl font-bold text-gray-800 mb-4">
          🥾 Track Your Thru-Hike Journey
        </h1>
        <p className="text-xl text-gray-600 mb-8">
          The ultimate trail companion for long-distance hikers
        </p>
        
        {!user && (
          <div className="space-x-4">
            <Link
              to="/register"
              className="inline-block bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-lg transition-colors"
            >
              Get Started Free
            </Link>
            <Link
              to="/login"
              className="inline-block bg-gray-200 hover:bg-gray-300 text-gray-800 font-bold py-3 px-8 rounded-lg transition-colors"
            >
              Login
            </Link>
          </div>
        )}

        {user && (
          <div className="space-x-4">
            <Link
              to="/hike/setup"
              className="inline-block bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-8 rounded-lg transition-colors"
            >
              Setup New Hike
            </Link>
            <Link
              to="/hike/update"
              className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-lg transition-colors"
            >
              Log Today's Entry
            </Link>
          </div>
        )}
      </div>

      {/* Features Grid */}
      <div className="grid md:grid-cols-3 gap-8 py-12">
        <div className="bg-white p-6 rounded-lg shadow-md">
          <div className="text-4xl mb-4">📴</div>
          <h3 className="text-xl font-bold mb-2">Works Offline</h3>
          <p className="text-gray-600">
            Log your daily progress even without cell reception. Data syncs automatically when you're back in service.
          </p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <div className="text-4xl mb-4">📊</div>
          <h3 className="text-xl font-bold mb-2">Detailed Analytics</h3>
          <p className="text-gray-600">
            Track distance, budget, RPE, mood, sleep quality, and more. Visualize your journey with beautiful charts.
          </p>
        </div>

        <div className="bg-white p-6 rounded-lg shadow-md">
          <div className="text-4xl mb-4">🎯</div>
          <h3 className="text-xl font-bold mb-2">Stay on Track</h3>
          <p className="text-gray-600">
            Monitor your distance remaining, budget status, and daily metrics to ensure you complete your hike successfully.
          </p>
        </div>
      </div>

      {/* Metrics Section */}
      <div className="bg-green-50 rounded-lg p-8 my-12">
        <h2 className="text-3xl font-bold text-center mb-8">Track Everything That Matters</h2>
        <div className="grid md:grid-cols-2 gap-6">
          <div className="flex items-start space-x-3">
            <span className="text-2xl">📏</span>
            <div>
              <h4 className="font-bold">Distance & Progress</h4>
              <p className="text-gray-600">Daily kilometers and total distance remaining</p>
            </div>
          </div>
          <div className="flex items-start space-x-3">
            <span className="text-2xl">💰</span>
            <div>
              <h4 className="font-bold">Budget Tracking</h4>
              <p className="text-gray-600">Daily spending and remaining budget</p>
            </div>
          </div>
          <div className="flex items-start space-x-3">
            <span className="text-2xl">💪</span>
            <div>
              <h4 className="font-bold">Physical Effort (RPE)</h4>
              <p className="text-gray-600">Rate your perceived exertion each day</p>
            </div>
          </div>
          <div className="flex items-start space-x-3">
            <span className="text-2xl">😊</span>
            <div>
              <h4 className="font-bold">Mood & Wellbeing</h4>
              <p className="text-gray-600">Track your emotional state and overall feeling</p>
            </div>
          </div>
          <div className="flex items-start space-x-3">
            <span className="text-2xl">😴</span>
            <div>
              <h4 className="font-bold">Sleep Quality</h4>
              <p className="text-gray-600">Monitor how well you're resting each night</p>
            </div>
          </div>
          <div className="flex items-start space-x-3">
            <span className="text-2xl">🌤️</span>
            <div>
              <h4 className="font-bold">Weather Conditions</h4>
              <p className="text-gray-600">Temperature and weather type for each day</p>
            </div>
          </div>
          <div className="flex items-start space-x-3">
            <span className="text-2xl">🔥</span>
            <div>
              <h4 className="font-bold">Calories Burned</h4>
              <p className="text-gray-600">Estimate your daily energy expenditure</p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="text-center py-12 bg-gradient-to-r from-green-600 to-green-700 rounded-lg text-white">
        <h2 className="text-3xl font-bold mb-4">Perfect for Te Araroa, PCT, AT, and More</h2>
        <p className="text-xl mb-8">Join hikers tracking their journeys on trails worldwide</p>
        {!user && (
          <Link
            to="/register"
            className="inline-block bg-white text-green-700 hover:bg-gray-100 font-bold py-3 px-8 rounded-lg transition-colors"
          >
            Start Tracking Free
          </Link>
        )}
      </div>

      {/* Footer Info */}
      <div className="text-center py-8 text-gray-600">
        <p>100% Free • No Ads • Your Data Stays Private</p>
      </div>
    </div>
  );
}

export default Home;
